import smCrypto from 'sm-crypto'

const sm2 = smCrypto.sm2

/** SM2 密文排列：1 = C1C3C2（与 Snowy / 多数后端约定一致），0 = C1C2C3 */
export const SM2_CIPHER_MODE_C1C3C2 = 1
export const SM2_CIPHER_MODE_C1C2C3 = 0

const defaultCipherMode = SM2_CIPHER_MODE_C1C3C2

/**
 * 默认 SM2 公钥（十六进制，非压缩点 04…），与后端协商一致后使用。
 * 若需按环境切换，可改为从 `import.meta.env` 读取或调用方传入 `publicKey`。
 */
export const DEFAULT_SM2_PUBLIC_KEY =
  '04298364ec840088475eae92a591e01284d1abefcda348b47eb324bb521bb03b0b2a5bc393f6b71dabb8f15c99a0050818b56b23f31743b93df9cf8948f15ddb54'

/**
 * SM2 加密（国密），返回十六进制密文字符串。
 *
 * @param plainText 明文字符串
 * @param publicKey 公钥，默认使用 {@link DEFAULT_SM2_PUBLIC_KEY}
 * @param cipherMode 密文排列，默认 C1C3C2
 */
export function sm2Encrypt(
  plainText: string,
  publicKey: string = DEFAULT_SM2_PUBLIC_KEY,
  cipherMode: number = defaultCipherMode,
): string {
  return sm2.doEncrypt(plainText, publicKey, cipherMode)
}

/**
 * 与 Snowy `doSm2ArrayEncrypt` 等价：当前实现与 `sm2Encrypt` 相同（均为字符串入参）。
 * 若业务需对二进制做 hex 编码后再加密，请先自行将 `Uint8Array` 转为 hex 字符串再调用。
 */
export function sm2EncryptArray(
  msgString: string,
  publicKey: string = DEFAULT_SM2_PUBLIC_KEY,
  cipherMode: number = defaultCipherMode,
): string {
  return sm2Encrypt(msgString, publicKey, cipherMode)
}

/**
 * SM2 解密（需与服务端下发的私钥一致；私钥切勿写死在前端生产环境，仅用于本地调试或明确场景）。
 *
 * @param cipherHex 十六进制密文
 * @param privateKey 私钥（十六进制）
 * @param cipherMode 须与加密时一致
 */
export function sm2Decrypt(
  cipherHex: string,
  privateKey: string,
  cipherMode: number = defaultCipherMode,
): string {
  return sm2.doDecrypt(cipherHex, privateKey, cipherMode)
}
